import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IEmployeeTimeOffState } from './employee-timeoff.types';
import {
  IEmployeeData,
  IEmployeeTimeOffBookingBalanceData,
  IEmployeeTimeOffData,
  IEmployeeWorkScheduleData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IEmployeeTimeOffState = {
  version: 1,
  employeeTimeOff: null as IEmployeeTimeOffData | null,
  employeeTimeOffEntitlementYears: [] as number[],
  employeeTimeOffEntitlementVacationYear: null,
  employeeTimeOffEntitlements: [],
  employeeTimeOffBalances: [] as IEmployeeTimeOffBookingBalanceData[],
  count: 0,
  lastPromise: null
};

const namespaced = true;

export const employeeTimeOff: Module<IEmployeeTimeOffState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
